import { getOwner } from '@ember/application';
import { action, computed, defineProperty, get } from '@ember/object';
function convert(str) {
  const input = [...str];
  const output = ['_'];
  let i = 0;
  while (i < input.length) {
    const part = input[i];
    if ((part === '/' || part === '-') && i !== input.length - 1) {
      const nextPart = input[i + 1].toUpperCase();
      output.push(nextPart);
      i = i + 2;
      continue;
    }
    output.push(part);
    i++;
  }
  return output.join('');
}
export const createSelect = serviceRegistrationKey => {
  const serviceInjectionName = convert(serviceRegistrationKey);
  const serviceAndStateKeyPath = `${serviceInjectionName}.state`;
  return selector => computed(serviceAndStateKeyPath, function () {
    const owner = getOwner(this);
    if (!get(this, serviceInjectionName)) {
      defineProperty(this, serviceInjectionName, {
        value: owner.lookup(`service:${serviceRegistrationKey}`),
        enumerable: false
      });
    }
    return selector == null ? get(this, serviceAndStateKeyPath) : selector(get(this, serviceAndStateKeyPath));
  }).readOnly();
};
export const createEmit = serviceRegistrationKey => (target, propertyKey, descriptor) => {
  const wrapped = descriptor.value;
  descriptor.value = function (...params) {
    const owner = getOwner(this);
    // FIXME(steckel): make registry access type-safe
    const workflowService = owner.lookup(`service:${serviceRegistrationKey}`);
    workflowService.emit(wrapped.call(this, ...params));
  };
  return action(target, propertyKey, descriptor);
};